import React, { useEffect, useState } from 'react'
import UnitCountTwo from './child/UnitCountTwo'
import { API_URL } from '..'
import DashboardFilter from './DashboardFilter'

const DashBoardLayerTwo = () => {
  const [data, setData] = useState({
    totalJobs: 0,
    activeJobs: 0,
    declinedJobs: 0,
    totalInvoices: 0,
    totalStaff: 0,
    newJobs: 0,
    completedJobs: 0,
  })

  const [filter, setFilter] = useState('all')
  const [customRange, setCustomRange] = useState({ startDate: '', endDate: '' })
  const [loading, setLoading] = useState(false)

  const fetchDashboard = async (selectedFilter, range = {}) => {
    setLoading(true)
    try {
      let url = `${API_URL}/api/job/dashboard?filter=${selectedFilter}`

      if (selectedFilter === 'custom' && range.startDate && range.endDate) {
        url += `&startDate=${range.startDate}&endDate=${range.endDate}`
      }

      const fetchApi = await fetch(url, { method: 'GET' })
      const response = await fetchApi.json()

      if (fetchApi.status === 200) {
        setData(response.data)
      }
    } catch (err) {
      console.error('Dashboard fetch error:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboard('all')
  }, [])

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter)
    if (newFilter !== 'custom') {
      fetchDashboard(newFilter)
    }
  }

  const handleCustomApply = () => {
    if (!customRange.startDate || !customRange.endDate) return
    fetchDashboard('custom', customRange)
  }

  return (
    <section className="row gy-4">
      <div className="col-12">
        <DashboardFilter
          filter={filter}
          onFilterChange={handleFilterChange}
          customRange={customRange}
          setCustomRange={setCustomRange}
          onCustomApply={handleCustomApply}
          loading={loading}
        />
      </div>

      <UnitCountTwo data={data} />
    </section>
  )
}

export default DashBoardLayerTwo